import { Brands } from '../../../../utils/enums/brands.enum';
import LegalDashboard from '../../../../components/LegalDashboard/index';
import TermsAndConditionsEnCA from './en-CA';
import TermsAndConditionsEnCAAudiDucati from './en-CADucatiAudi';
import TermsAndConditionsEnUSA from './en-US';
import TermsAndConditionsEnUSDucatiAudi from './en-USDucatiAudi';
import TermsAndConditionsFrCA from './fr-CA';
import TermsAndConditionsFrCADucatiAudi from './fr-CADucatiAudi';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getUrlParameter, isSiteCanadian } from '../../../../utils/helpers';
import React, { useEffect, useMemo } from 'react';

const getTermsAndConditionsComponent = (
    language: string,
    isCADomain: boolean,
    brand: Brands | null,
) => {
    if (language.includes('en-')) {
        if (isCADomain) {
            return brand === Brands.AUDI || brand === Brands.DUCATI ? (
                <TermsAndConditionsEnCAAudiDucati />
            ) : (
                <TermsAndConditionsEnCA />
            );
        } else {
            return brand === Brands.AUDI || brand === Brands.DUCATI ? (
                <TermsAndConditionsEnUSDucatiAudi />
            ) : (
                <TermsAndConditionsEnUSA />
            );
        }
    } else {
        return brand === Brands.AUDI || brand === Brands.DUCATI ? (
            <TermsAndConditionsFrCADucatiAudi />
        ) : (
            <TermsAndConditionsFrCA />
        );
    }
};

const TermsAndConditions: React.FC = () => {
    const { i18n } = useTranslation();
    const location = useLocation();

    useEffect(() => {
        const lang = getUrlParameter(location, 'lang');

        if (lang === 'en-US' || lang === 'en-CA' || lang === 'fr-CA') {
            i18n.changeLanguage(lang);
        }
    }, [location, i18n]);

    const brand = getUrlParameter(location, 'brand') as Brands | null;

    const isCADomain = isSiteCanadian();

    const termsAndConditionsText = useMemo(
        () => getTermsAndConditionsComponent(i18n.language, isCADomain, brand),
        [i18n.language, isCADomain, brand],
    );

    return <LegalDashboard>{termsAndConditionsText}</LegalDashboard>;
};

export default TermsAndConditions;
